__turbopack_context__.v({
  "stat": "style-module-scss-module__a0PkvG__stat",
  "stat-description": "style-module-scss-module__a0PkvG__stat-description",
  "stat-number": "style-module-scss-module__a0PkvG__stat-number",
});
